import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { prefetchRoutes } from '@/lib/prefetch';

// Define which routes to prefetch based on current location
const prefetchMap: Record<string, string[]> = {
  '/': ['/auth', '/dashboard'],
  '/auth': ['/dashboard', '/upload'],
  '/dashboard': ['/courses', '/calendar', '/grades', '/ace', '/materials'],
  '/courses': ['/dashboard', '/calendar'],
  '/calendar': ['/dashboard', '/courses'],
  '/grades': ['/dashboard', '/courses'],
  '/materials': ['/dashboard', '/courses'],
  '/ace': ['/dashboard', '/courses', '/calendar'],
  '/upload': ['/preview', '/dashboard'],
  '/preview': ['/dashboard', '/courses'],
  '/account': ['/dashboard'],
};

// Core routes to always prefetch after initial load
const coreRoutes = ['/dashboard', '/courses', '/calendar', '/ace'];

export function usePrefetch() {
  const location = useLocation();

  useEffect(() => {
    // Prefetch routes relevant to current page
    const routesToPrefetch = prefetchMap[location.pathname] || [];
    
    // Use requestIdleCallback for non-blocking prefetch
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        prefetchRoutes(routesToPrefetch);
      }, { timeout: 2000 });
    } else {
      // Fallback for Safari
      setTimeout(() => {
        prefetchRoutes(routesToPrefetch);
      }, 100);
    }
  }, [location.pathname]);

  // Prefetch core routes on initial app load
  useEffect(() => {
    const timer = setTimeout(() => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          prefetchRoutes(coreRoutes);
        }, { timeout: 3000 });
      } else {
        prefetchRoutes(coreRoutes);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);
}
